import React, { useContext } from "react";
import { WebsiteHeaderProps } from "../../types/wizard.types";
import { AppContext } from "../../../../context/app";

const WebsiteHeader: React.FC<WebsiteHeaderProps> = ({
  logo,
  brandColor,
  businessName,
  businessUrl,
}) => {
  const { client } = useContext(AppContext);
  const { company } = client;

  return (
    <header
      className="tw-border-b tw-transition-all tw-duration-500"
      style={{ borderColor: `${brandColor}20` }}
    >
      {/* Top Header Bar */}
      <div
        className="tw-h-16 tw-flex tw-items-center tw-px-6 tw-text-white"
        style={{ backgroundColor: brandColor }}
      >
        <div className="tw-flex tw-items-center tw-gap-3">
          {logo && (
            <img
              src={logo}
              alt={`${businessName} logo`}
              className="tw-w-10 tw-h-10 tw-object-contain tw-rounded tw-p-1"
            />
          )}
          <div>
            <h1 className="tw-text-xl tw-font-semibold">{company}</h1>
            <p className="tw-text-sm tw-opacity-90">{businessUrl}</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default WebsiteHeader;
